import { html } from '../utils/classes'

export function webflowEditor() {
  html.classList.add('is-editor');
}